import React from "react";

import { SingleSelect } from "widgets";

import {
  UPLOAD_COPY,
  UPLOAD_FIELD_IDS,
} from "../constants/uploadsContent";
import styles from "../containers/Uploads/UploadsContainer.module.scss";

const UploadActionField = ({
  menuItems,
  value,
  onChange,
}) => (
  <div className={styles.actionField}>
    <label className={styles.fieldLabel} htmlFor={UPLOAD_FIELD_IDS.ACTION}>
      {UPLOAD_COPY.ACTION_LABEL}{" "}
      <span className={styles.required}>*</span>
    </label>
    <div className={styles.actionInputRow}>
      <div className={styles.selectWrapper}>
        <SingleSelect
          menuItems={menuItems}
          value={value}
          placeholder={UPLOAD_COPY.ACTION_PLACEHOLDER}
          handleChange={onChange}
          hideNoneOption
          fullWidth
        />
      </div>
      <p className={styles.actionHint}>{UPLOAD_COPY.ACTION_HINT}</p>
    </div>
  </div>
);

export default UploadActionField;
